/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { StaticPageDetailAdmin } from './StaticPageDetailAdmin'
import {
  StaticPageDetailAdminFromJSON,
  StaticPageDetailAdminFromJSONTyped,
  StaticPageDetailAdminToJSON,
} from './StaticPageDetailAdmin'

/**
 *
 * @export
 * @interface EnvelopedStaticPageStaticPageDetailAdmin
 */
export interface EnvelopedStaticPageStaticPageDetailAdmin {
  /**
   *
   * @type {StaticPageDetailAdmin}
   * @memberof EnvelopedStaticPageStaticPageDetailAdmin
   */
  body: StaticPageDetailAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedStaticPageStaticPageDetailAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedStaticPageStaticPageDetailAdmin interface.
 */
export function instanceOfEnvelopedStaticPageStaticPageDetailAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedStaticPageStaticPageDetailAdminFromJSON(
  json: any,
): EnvelopedStaticPageStaticPageDetailAdmin {
  return EnvelopedStaticPageStaticPageDetailAdminFromJSONTyped(json, false)
}

export function EnvelopedStaticPageStaticPageDetailAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedStaticPageStaticPageDetailAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: StaticPageDetailAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedStaticPageStaticPageDetailAdminToJSON(
  value?: EnvelopedStaticPageStaticPageDetailAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: StaticPageDetailAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
